<template>
  <el-form
    v-bind="$attrs"
    ref="form"
    :model="Model"
    :show-message="showMessage"
    :status-icon="statusIcon"
    :inline="inline"
  >
    <template v-for="(item, index) in _formItems">
      <el-form-item
        v-if="item._ifRender"
        :key="index + item.attrs.key"
        v-bind="item.itemAttrs || {}"
        :ref="item.ref"
        :class="item.itemAttrs.className"
        :prop="item.attrs.key"
      >
        <!--将表单内部的数据通过作用域插槽传给外部-->
        <slot v-if="item.slot" :name="item.slot" :scope="Model" />
        <component
          :is="item.tag"
          v-else
          v-model="Model[item.attrs.key]"
          :class="item.itemAttrs.className"
          v-bind="item.attrs || {}"
          v-on="item.listeners || {}"
        />
      </el-form-item>
    </template>

    <el-form-item v-if="submit || reset || searchButtons.length > 0">
      <el-button v-if="submit" type="primary" @click="handleSubmit">{{
        $attrs.submitContext || "查询"
      }}</el-button>
      <el-button v-if="reset" @click="handleReset">{{
        $attrs.resetContext || "重置"
      }}</el-button>
      <template v-if="searchButtons.length > 0">
        <template v-for="btn in searchButtons">
          <el-upload
            v-if="btn.type === 'upload'"
            :key="btn.text"
            :action="btn.action"
            :file-list="fileList"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :on-change="btn.onChange"
            :on-error="handleUploadError"
            :data="btn.uploadData"
            with-credentials
            :auto-upload="!!btn.action"
            :disabled="btn.disabled"
            style="display: inline-block; margin-left: 10px; margin-right: 10px"
          >
            <el-button type="success">{{ btn.text }}</el-button>
          </el-upload>
          <el-tooltip
            v-else-if="btn.tooltip"
            :key="btn.text"
            class="item"
            effect="dark"
            :content="btn.tooltipContent"
            placement="top"
          >
            <el-button
              :key="btn.text"
              :type="btn.type"
              :disabled="btn.disabled"
              @click="$emit(btn.emitter)"
              >{{ btn.text }}</el-button
            >
          </el-tooltip>

          <el-button
            v-else
            :key="btn.text"
            :type="btn.type"
            :disabled="btn.disabled"
            @click="$emit(btn.emitter)"
            >{{ btn.text }}</el-button
          >
        </template>
      </template>
    </el-form-item>
  </el-form>
</template>

<script>
import VueEditor from "yimo-vue-editor";
import { basic } from "./BASIC";
import { findComponentUpwardByProp } from "@/utils/findComponents.js";
import { proxyProp } from "@/utils/proxyProp.js";
import BaseSelect from "@/components/BaseSelect/BaseSelect.vue";

export default {
  name: "BaseForm",
  components: {
    BaseSelect,
    VueEditor,
  },
  props: {
    formItems: {
      type: Array,
      required: true,
    },
    searchButtons: {
      type: Array,
      default: () => [],
    },
    submit: {
      type: Boolean,
      default: true,
    },
    reset: {
      type: Boolean,
      default: true,
    },
    // 传入mergeForm允许父组件修改内部Model对象
    mergeForm: {
      type: Object,
      default: () => ({}),
    },
    formName: {
      // 表单的变量名，用来找到父组件
      type: String,
      default: "mergeForm",
    },
  },
  data() {
    return {
      Model: {},
      originModel: {},
      form: "form",
      fileList: [],
    };
  },
  computed: {
    // 根据formItem计算出实际需要让页面渲染的真正的_formItem数据
    _formItems() {
      // this.Model中的值改变触发computed
      let _formItems = [];
      _formItems = this.formItems.map((item) =>
        this.computeFormItem(item, this.Model)
      );
      return _formItems;
    },
    showMessage() {
      return this.$attrs["show-message"] !== false;
    },
    statusIcon() {
      return this.$attrs["status-icon"] !== false;
    },
    inline() {
      return this.$attrs.inline !== false;
    },
  },
  watch: {
    // 使用watch观察父组件传入的formItems,初始化Model对象(只调用一次)
    formItems: {
      handler(newVal) {
        this.formItems.forEach((formItem) => {
          if (!formItem.attrs || !formItem.attrs.key) return; // 跳过没有key的属性(插槽)
          if (this.Model.hasOwnProperty(formItem.attrs.key)) return; // 已经存在字段，不需要再set

          this.$set(
            this.Model,
            formItem.attrs.key,
            formItem.attrs.value ? formItem.attrs.value : "" // 默认值
          );
        });
        this.originModel = JSON.parse(JSON.stringify(this.Model));
      },
      deep: true,
      immediate: true,
    },
    mergeForm: {
      handler() {
        this.mergeModel();
      },
      deep: true,
      immediate: true,
    },
    formName: {
      handler(newVal) {
        this.proxyParentForm(newVal);
      },
      deep: true,
      immediate: true,
    },
    Model: {
      deep: true,
      immediate: true,
      handler(newVal) {
        // 找到父组件的表单对象，并同步Model的值
        const parentComponent = findComponentUpwardByProp(this, this.formName);
        parentComponent[this.formName] = newVal;
      },
    },
  },
  mounted() {
    // 代理父组件的mergeForm属性
    // let parentComponent = findComponentUpwardByProp(this, "mergeForm");
    // if (parentComponent) {
    //   parentComponent.mergeForm = proxyProp(parentComponent.mergeForm);
    // } else {
    //   throw new Error("cannot find parentComponent");
    // }
    // this.proxyParentForm(this.formName);
    // mounted钩子中formItems是空数组,所以不在mounted里面操作formItems
  },
  methods: {
    handleUploadSuccess(res, file, fileList) {
      console.log(
        "🚀 ~ file: BaseForm.vue ~ line 211 ~ handleUploadSuccess ~ handleUploadSuccess"
      );
      if (res.code !== 200) {
        this.$message({ message: res.msg, type: "error" });
      } else {
        this.$message.success("上传成功");
        this.$emit("upload-success", res, file, fileList);
      }
    },
    handleUploadError(err, file, fileList) {
      console.log(
        "🚀 ~ file: BaseForm.vue ~ line 220 ~ handleUploadError ~ handleUploadError",
        err
      );
      this.$message.error(err);
      this.$emit("upload-error", err, file, fileList);
    },
    proxyParentForm(formName) {
      // 代理父组件的mergeForm属性
      const parentComponent = findComponentUpwardByProp(this, formName);
      if (parentComponent) {
        parentComponent[formName] = proxyProp(parentComponent[formName]);
      } else {
        throw new Error("cannot find parentComponent");
      }
    },
    computeFormItem(formItem, Model) {
      const item = { ...formItem };
      // 表单控件的类型
      const tag = item.tag || "input";
      // 对应到组件映射表
      const basicItem = basic[tag];

      item.tag = basicItem.component;
      // 继承基类的属性
      item.attrs = { ...basicItem.attrs, ...item.attrs };
      // 获取动态 Attributes
      if (item.getAttrs)
        item.attrs = Object.assign(item.attrs, item.getAttrs(Model));
      // 条件渲染
      item._ifRender = item.ifRender ? item.ifRender(Model) : true;
      // 防止表单提交时存在多余 key
      if (!item._ifRender) {
        delete Model[item.attrs.key];
      }
      // form-item 配置
      return item;
    },
    mergeModel() {
      Object.assign(this.Model, this.mergeForm);
    },
    // 提交按钮
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.$emit("submit", this.Model);
        }
      });
    },
    handleReset() {
      // 因为后端接收两个时间的字段来控制范围，因此需要emit事件，并带上date数组，在页面上watch date数组变化从而更新这两个字段
      // 后续估计让后端接收数组比较好，组件的value直接就是数组，不需要再转化为两个字段给后端
      this.Model = JSON.parse(JSON.stringify(this.originModel));
      this.$emit("reset", this.Model);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/BaseForm/BaseForm.vue